/** In-app Stripe checkout / plan selection (RealmRouter). */
export const BILLING_UPGRADE_PATH = '/billing/upgrade';

/** Marketing site pricing (canonical on app host). */
export const MARKETING_PRICING_URL = 'https://app.memara.io/pricing';

/** Marketing site integrations directory (canonical on app host). */
export const MARKETING_INTEGRATIONS_URL = 'https://app.memara.io/integrations';
